import type { DecoratorTypeValue } from "@/components/suggestions/providers/data/types";
import type { NodeModel } from "@/models/nodes/types";

export function hasDecorator(node?: NodeModel, decoratorType?: DecoratorTypeValue) {
  if (!node) {
    return false;
  }

  let decoratorNode: NodeModel | undefined = node;

  if ("symbolNode" in node) {
    decoratorNode = node.symbolNode;
  }

  if (decoratorNode && "decorators" in decoratorNode) {
    if (!decoratorType) {
      return decoratorNode.decorators.length > 0;
    }

    return decoratorNode.decorators.some((decorator) => decorator.name === decoratorType);
  }

  return false;
}

export function addDecoratorToText(text: string, name?: DecoratorTypeValue) {
  switch (name) {
    case "vector":
    case "bar": {
      // Example output: r̅e̅v̅e̅n̅u̅e̅
      return text
        .split("")
        .map((char) => `${char}\u0305`)
        .join("");
    }

    case "hat": {
      // Example output: x̂
      return text
        .split("")
        .map((char) => `${char}\u0302`)
        .join("");
    }

    default: {
      return text;
    }
  }
}
